var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "appManutencao" } },
    [
      _c("vue-progress-bar"),
      _vm.loader.status
        ? _c("div", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loader.status,
                expression: "loader.status"
              },
              {
                name: "loading",
                rawName: "v-loading.fullscreen.lock",
                value: true,
                expression: "true",
                modifiers: { fullscreen: true, lock: true }
              }
            ],
            attrs: { "element-loading-text": _vm.loader.text }
          })
        : _vm._e(),
      _c(
        "header",
        [
          _c("main-header", {
            attrs: { notificacao: false, isManutencao: true }
          })
        ],
        1
      ),
      _c("main", { staticClass: "container" }, [
        !_vm.isMaranhao
          ? _c(
              "div",
              { staticClass: "scroll-overflow" },
              [_c("side-menu-lazy", { attrs: { items: _vm.items } })],
              1
            )
          : _c(
              "div",
              [_c("side-menu-lazy", { attrs: { items: _vm.items } })],
              1
            ),
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            {
              staticClass: "container-router",
              attrs: { "body-style": { width: "100%" }, shadow: "hover" }
            },
            [
              _c("router-view"),
              _c("router-view", { attrs: { name: "filtro" } }),
              _c("router-view", { attrs: { name: "listagem" } })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-481ff797", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-481ff797","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/MainPage.vue
// module id = null
// module chunks = 